import angular from 'angular';
import _ from 'lodash';

(function() {
    'use strict';
    angular.module('app.admin.monitoring').factory('MonitoringSvc', MonitoringSvc);

    MonitoringSvc.$inject = ['$http'];

    /* @ngInject */
    function MonitoringSvc($http) {
        var exports = {
            getIndicatorsList: getIndicatorsList,
            getIndicatorHealth: getIndicatorHealth
        };

        return exports;

        function getIndicatorsList(baseUrl) {
            var url = baseUrl + '/list';
            return $http.get(url).then(function(result) {
                return result.data;
            });
        }

        function getIndicatorHealth(baseUrl, indicatorInfo) {
            var url = baseUrl + '/' + indicatorInfo.name;
            return $http.get(url).then(
                function(result) {
                    return formatHealthData(result.data, indicatorInfo);
                },
                function(/*error*/) {
                    return {
                        status: 'UNKNOWN',
                        title: indicatorInfo.title,
                        desc: indicatorInfo.description,
                        order: indicatorInfo.order
                    };
                }
            );
        }

        function formatHealthData(data, indicatorInfo) {
            var indicator = {
                status: data.status,
                title: indicatorInfo.title,
                desc: indicatorInfo.description,
                order: indicatorInfo.order
            };
            var subIndicatorsData = _.omit(data, ['status']);
            indicator.subindicators = [];
            indicator.extraInfos = {};
            var index = 0;
            angular.forEach(subIndicatorsData, function(value, key) {
                //check si un sous indicateur
                if (value.status) {
                    indicator.subindicators[index++] = {
                        name: key,
                        status: value.status,
                        extraInfos: _.omit(value, ['status'])
                    };
                } else {
                    indicator.extraInfos[key] = value;
                }
            });
            return indicator;
        }
    }
})();
